import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus-box",
  "use": "plus-box-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"plus-box\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path stroke-width=\"2\" d=\"M1 1.956h10v10.01H1z\" />\n        <path stroke=\"#FFF\" fill=\"#FFF\" d=\"M4 4.96h9v9.006H4z\" />\n        <g stroke-width=\"2\">\n            <path d=\"M11 7.462v9.007M15.5 11.965h-9\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol